import connectivityMonitorMessages from
  'ringcentral-integration/modules/ConnectivityMonitor/connectivityMonitorMessages';

export default {
  [connectivityMonitorMessages.disconnected]: 'Die Netzwerkverbindung ist unterbrochen.',
};
